import * as React from 'react';
import Dropdown from '../../common/Dropdown';
import TableHeader from '../../TableHeader';
import OutwardIntegrationResult from '../../../domain/OutwardIntegrationResult';

export type Type = 'estimations' | 'orders';

interface Props {
    label: string;
    type: Type;
    headers: string[];
    filters: string[];
    filterChanged: (filter: string, type: Type) => void;
    items: OutwardIntegrationResult[];
    row: (orderData: OutwardIntegrationResult, selectedFilter: string) => JSX.Element;
    selected: string;
}

export default class OutwardIntegration extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <>
                <div className="panel-table-header">
                    <h2>{this.props.label}</h2>
                    <Dropdown
                        onChange={this.onOrderFilterChange}
                        options={this.props.filters}
                        class="admin-select"
                        color="gray"
                        placeholder={this.props.selected}
                    />
                </div>
                <div className="panel-table-wrapper">
                    <TableHeader headers={this.props.headers} class="user-orders-header" />
                    {this.props.items.map((orderData: OutwardIntegrationResult) => {
                        return this.props.row(orderData, this.props.selected);
                    })}
                </div>
            </>
        );
    }

    private onOrderFilterChange = (value: string): void => {
        this.props.filterChanged(value, this.props.type);
    };
}



// WEBPACK FOOTER //
// ./src/view/admin/integration/OutwardIntegration.tsx